import React, {useContext} from "react";
import {TimelineFrameCareUnitContext} from "../../careunitdetails/TimelineFrameContentCareUnitWrapper";
import Row from "../../../../../../../components/tag/Row";
import Span from "../../../../../../../components/tag/Span";
import {FormattedMessage} from "react-intl";
import {OTLink} from "../../../../../../../components/tag/OTLink";

let { id: module_id } = module;

const TimelineFrameContentAppointmentCareUnit = () => {
    const careUnit = useContext(TimelineFrameCareUnitContext);

    if (careUnit) {
        return (
            <Row>
                <Span>
                    <FormattedMessage id={`${module_id}.reschedule.appointment`}
                                      values={{
                                          a: (chunks) => <OTLink
                                              target="_blank"
                                              onClick={(e) => e.stopPropagation()}
                                              link={careUnit.linkValue}
                                              isExternal={true}
                                              className="card-link"
                                          >{chunks}</OTLink>,
                                          br: <br />
                                      }} />
                </Span>
            </Row>
        )
    }

}

export default TimelineFrameContentAppointmentCareUnit;